import eventRepo     from '../services/events';
import courseRepo    from '../services/courses';
import timetableRepo from '../services/timetables';
import presenterRepo from '../services/presenters';
import venueRepo     from '../services/venues';
import resourcesRepo from '../services/resourcePacks';

export const EVENTS_REFRESHED             = 'EVENTS_REFRESHED';
export const PUBLIC_EVENTS_REFRESHED      = 'PUBLIC_EVENTS_REFRESHED';
export const TIMETABLES_REFRESHED         = 'TIMETABLES_REFRESHED';
export const COURSES_REFRESHED            = 'COURSES_REFRESHED';
export const VENUES_REFRESHED             = 'VENUES_REFRESHED';
export const PRESENTERS_REFRESHED         = 'PRESENTERS_REFRESHED';
export const SHOW_EVENT_ATTENDEES         = 'SHOW_EVENT_ATTENDEES';
export const HIDE_EVENT_ATTENDEES         = 'HIDE_EVENT_ATTENDEES';
export const SHOW_NEW_EVENT_OVERLAY       = 'SHOW_NEW_EVENT_OVERLAY';
export const HIDE_NEW_EVENT_OVERLAY       = 'HIDE_NEW_EVENT_OVERLAY';
export const HIDE_DELETE_EVENT_OVERLAY    = 'HIDE_DELETE_EVENT_OVERLAY';
export const SHOW_DELETE_EVENT_OVERLAY    = 'SHOW_DELETE_EVENT_OVERLAY';
export const HIDE_EDIT_EVENT_OVERLAY      = 'HIDE_EDIT_EVENT_OVERLAY';
export const SHOW_EDIT_EVENT_OVERLAY      = 'SHOW_EDIT_EVENT_OVERLAY';
export const SHOW_EDIT_ATTENDEE_OVERLAY   = 'SHOW_EDIT_ATTENDEE_OVERLAY';
export const SHOW_DELETE_ATTENDEE_OVERLAY = 'SHOW_DELETE_ATTENDEE_OVERLAY';
export const RESOURCE_PACKS_REFRESHED     = 'RESOURCE_PACKS_REFRESHED';
export const HIDE_EDIT_ATTENDEE_OVERLAY   = 'HIDE_EDIT_ATTENDEE_OVERLAY';
export const HIDE_DELETE_ATTENDEE_OVERLAY = 'HIDE_DELETE_ATTENDEE_OVERLAY';
export const SHOW_ADD_ATTENDEE_OVERLAY    = 'SHOW_ADD_ATTENDEE_OVERLAY';
export const HIDE_ADD_ATTENDEE_OVERLAY    = 'HIDE_ADD_ATTENDEE_OVERLAY';
export const ATTENDEE_SELECT_CHANGED      = 'ATTENDEE_SELECT_CHANGED';
export const TOGGLE_SELECT_ALL_ATTENDEES  = 'TOGGLE_SELECT_ALL_ATTENDEES';
export const RESET_SELECT_ALL_ATTENDEES   = 'RESET_SELECT_ALL_ATTENDEES';
export const EVENT_FILTER_DATE_CHANGED    = 'EVENT_FILTER_DATE_CHANGED';
export const SORT_EVENT_ATTENDEES         = 'SORT_EVENT_ATTENDEES';
export const WEBSITE_DISPLAY_POSITIONS_AVAILABLE = 'WEBSITE_DISPLAY_POSITIONS_AVAILABLE';

export function toggleAttendingMultipleDays(attendee) {

    return (dispatch) => {

        function updateSuccess() {

            dispatch(refreshEvents());
        }

        const attendeeParams = {
            ...attendee,
            attending_all_days: !attendee.attending_all_days
        };

        eventRepo.updateAttendee(attendeeParams)
            .then(updateSuccess);
    };
}

export function sortAttendees(eventId, attribute, direction) {

    return {
        type: SORT_EVENT_ATTENDEES,
        eventId,
        attribute,
        direction
    };
}

export function filterEventsByDate(fromDate) {

    return {
        type: EVENT_FILTER_DATE_CHANGED,
        fromDate
    };
}

export function resetSelectAllAttendees(eventId) {

    return {
        type: RESET_SELECT_ALL_ATTENDEES,
        eventId
    };
}

export function toggleSelectAllAttendees(eventId) {
    
    return {
        type: TOGGLE_SELECT_ALL_ATTENDEES,
        eventId
    };
}

export function attendeeSelectionChanged(eventId, attendeeId, isSelected) {

    return {
        type: ATTENDEE_SELECT_CHANGED,
        eventId,
        attendeeId,
        isSelected
    };
}

export function showAddAttendeeOverlay(eventId) {

    return {
        type: SHOW_ADD_ATTENDEE_OVERLAY,
        eventId
    };
}

export function hideAddAttendeeOverlay() {

    return {
        type: HIDE_ADD_ATTENDEE_OVERLAY
    };
}

export function deleteAttendee(attendeeId) {

    return (dispatch) => {

        function deleteSuccess() {

            dispatch(refreshEvents());
            dispatch(hideDeleteAttendeeOverlay());
        }

        eventRepo.deleteAttendee(attendeeId)
            .then(deleteSuccess);
    }
}

export function hideEditAttendeeOverlay() {

    return {
        type: HIDE_EDIT_ATTENDEE_OVERLAY
    };
}

export function hideDeleteAttendeeOverlay() {

    return {
        type: HIDE_DELETE_ATTENDEE_OVERLAY
    };
}

export function showEditAttendeeOverlay(attendee) {

    return {
        type: SHOW_EDIT_ATTENDEE_OVERLAY,
        attendee
    };
}

export function showDeleteAttendeeOverlay(attendee) {

    return {
        type: SHOW_DELETE_ATTENDEE_OVERLAY,
        attendee
    };
}

export function deleteEvent(eventId) {

    return (dispatch) => {

        function deleteSuccess() {

            dispatch(hideDeleteEventOverlay());
            dispatch(refreshEvents());
        }

        eventRepo.remove(eventId)
            .then(deleteSuccess);
    };
}

export function showEditEventOverlay(event) {

    return {
        type: SHOW_EDIT_EVENT_OVERLAY,
        event
    }
}

export function hideEditEventOverlay() {

    return {
        type: HIDE_EDIT_EVENT_OVERLAY
    }
}

export function showDeleteEventOverlay(event) {

    return {
        type: SHOW_DELETE_EVENT_OVERLAY,
        event
    }
}

export function hideDeleteEventOverlay() {

    return {
        type: HIDE_DELETE_EVENT_OVERLAY
    }
}

export function timetablesRefreshed(timetables) {

    return {
        type: TIMETABLES_REFRESHED,
        timetables
    };
}

export function coursesRefreshed(courses) {

    return {
        type: COURSES_REFRESHED,
        courses
    };
}

export function resourcePacksRefreshed(resourcePacks) {

    return {
        type: RESOURCE_PACKS_REFRESHED,
        resourcePacks
    };
}

export function presentersRefreshed(presenters) {

    return {
        type: PRESENTERS_REFRESHED,
        presenters
    };
}

export function venuesRefreshed(venues) {

    return {
        type: VENUES_REFRESHED,
        venues
    };
}

export function refreshEventOptions() {

    return (dispatch) => {

        function getVenuesSuccess(response) {

            dispatch(venuesRefreshed(response.data.data));
        }

        function getPresentersSuccess(response) {

            dispatch(presentersRefreshed(response.data.data));
        }

        function getResourcePacksSuccess(response) {

            dispatch(resourcePacksRefreshed(response.data.data));
        }

        function getCoursesSuccess(response) {

            dispatch(coursesRefreshed(response.data.data));
        }

        function getTimetablesSuccess(response) {

            dispatch(timetablesRefreshed(response.data.data));
        }

        venueRepo.getAll().then(getVenuesSuccess);
        presenterRepo.getAll().then(getPresentersSuccess);
        resourcesRepo.getAll().then(getResourcePacksSuccess);
        courseRepo.getAll().then(getCoursesSuccess);
        timetableRepo.getAll().then(getTimetablesSuccess);
    };
}

export function showNewEventOverlay() {

    return {
        type: SHOW_NEW_EVENT_OVERLAY
    };
}

export function hideNewEventOverlay() {

    return {
        type: HIDE_NEW_EVENT_OVERLAY
    };
}

export function showAttendees(eventId) {

    return {
        type: SHOW_EVENT_ATTENDEES,
        eventId
    };
}

export function hideAttendees(eventId) {

    return {
        type: HIDE_EVENT_ATTENDEES,
        eventId
    };
}

export function eventsRefreshed(events) {
    return {
        type: EVENTS_REFRESHED,
        events
    };
}

export function publicEventsRefreshed(events) {

    return {
        type: PUBLIC_EVENTS_REFRESHED,
        events
    };
}

export function websiteAvailablePositionsRefreshed(websiteDisplayPositionsAvailable) {

    return {
        type: WEBSITE_DISPLAY_POSITIONS_AVAILABLE,
        websiteDisplayPositionsAvailable
    };
}

export function refreshEvents() {

    return (dispatch, getState) => {

        function getSuccess(response) {

            dispatch(eventsRefreshed(response.data.data));
        }

        const fromDate = getState().adminEventList.filterDate;

        if (fromDate) {

            eventRepo.getAll({ fromDate })
                .then(getSuccess);

        } else {

            eventRepo.getAll()
                .then(getSuccess);
        }
    }
}

export function refreshPublicEvents() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(publicEventsRefreshed(response.data.data));
        }

        eventRepo.getPublicEvents().then(getSuccess);

    }
}

export function refreshFeaturedEvents() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(publicEventsRefreshed(response.data.data));
        }

        eventRepo.getFeaturedEvents().then(getSuccess);

    }
}

export function refreshWebsiteDisplayPositionsAvailable() {
    return (dispatch) => {

        function getSuccess(response) {

            dispatch(websiteAvailablePositionsRefreshed(response.data.data));
        }

        eventRepo.getWebsiteAvailablePositions().then(getSuccess);

    }
}


// WEBPACK FOOTER //
// ./actions/eventList.js